/* __next_internal_client_entry_do_not_use__ WithSearchPageErrorBoundary,SearchPageErrorHandler auto */ import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LazySearchProductsError } from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsError/index";
import { SearchPageLogErrorEffect } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageEffects/SearchPageLogErrorEffect";
import { useSearchPageIsError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageIsError";
import React, { Suspense } from "react";
export var WithSearchPageErrorBoundary = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(ErrorBoundary, {
        children: [
            children,
            /*#__PURE__*/ _jsx(SearchPageErrorListener, {})
        ]
    });
};
// An adapter to use ErrorBoundary with Suspense when .error from context is true
var SearchPageErrorListener = function() {
    var isError = useSearchPageIsError();
    if (isError) {
        // delegate error to ErrorBoundary
        throw new Error("SearchPageError");
    }
    return null;
};
var ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(ErrorBoundary, _React_Component);
    function ErrorBoundary() {
        _class_call_check(this, ErrorBoundary);
        var _this;
        _this = _call_super(this, ErrorBoundary, arguments);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.render = function render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ _jsx(SearchPageErrorHandler, {});
        }
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(React.Component);
export var SearchPageErrorHandler = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SearchPageLogErrorEffect, {}),
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazySearchProductsError, {})
            })
        ]
    });
};
